module.exports = __webpack_public_path__ + "img/cross.45fc150d.svg";